import { RouterProvider } from "react-router";
import { ThemeProvider } from "@/lib/theme-context";
import { QueryProvider } from "@/components/providers/query-provider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/lib/auth-context";
import { Toaster } from "@/components/ui/sonner";
import { router } from "@/router";

export function App() {
  return (
    <ThemeProvider defaultTheme="system" attribute="class" enableSystem>
      <QueryProvider>
        <TooltipProvider>
          <AuthProvider>
            <RouterProvider router={router} />
            <Toaster />
          </AuthProvider>
        </TooltipProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
